import type { TCountry } from "../types/outerLayout/common";

type TJordanExcludedCountries = Exclude<TCountry, 'JOR'>;
type TFEDomain = TJordanExcludedCountries | "ALPHA" | "BETA" | "LOCAL_HOST";

export const FE_DOMAINS: { [key in TFEDomain]: string } = {
  EGY: "eg.dashboard.paymob.com",
  SAU: "ksa.dashboard.paymob.com",
  ARE: "uae.dashboard.paymob.com",
  OMN: "om.dashboard.paymob.com",
  PAK: "pk.dashboard.paymob.com",
  ALPHA: "alpha.dashboard.paymob.com",
  BETA: "beta.dashboard.paymob.com",
  LOCAL_HOST: "localhost"
};
